export var ShowHelp;
(function (ShowHelp) {
    ShowHelp["tooltip"] = "tooltip";
    ShowHelp["newLine"] = "newLine";
    ShowHelp["label"] = "label";
    ShowHelp["none"] = "none";
})(ShowHelp || (ShowHelp = {}));
